<template>
  <PopupNotification
    :show="open"
    :title="title"
    :subtitle="subtitle"
    class="bg-error text-primary text-white"
    close-button-class="bg-error text-white"
    error
    @close="close"
  >
  </PopupNotification>
</template>

<script>
import PopupNotification from "./PopupNotification.vue";
import { useNotificationStore } from "../../../store/v2/notification";

export default {
  name: "ErrorPopupNotification",
  components: {
    PopupNotification,
  },
  props: {
    id: Number,
    title: String,
    subtitle: String,
  },
  setup() {
    const notificationStore = useNotificationStore();

    return {
      notificationStore,
    };
  },
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    // Timeouts necessary for rendering animations
    setTimeout(() => {
      this.open = true;
    }, 200);
    setTimeout(() => {
      this.close();
    }, 6000);
  },
  methods: {
    close() {
      this.open = false;
      setTimeout(() => {
        this.notificationStore.removeNotification(this.id);
      }, 300);
    },
  },
};
</script>
